<template>
  <div  class="flex flex-wrap">
      <div class="w-full sm:w-full md:w-full lg:w-3/6 xl:w-3/6">
      <ShipsAtPort />
      <ContainerSearch />
      <OverallStatistics />
      <EstimatedArrival />
    </div>

    
    <div class="w-full sm:w-full md:w-full lg:w-3/6 xl:w-3/6">
      <div class="flex flex-wrap">
        <div class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
          <a href="https://port.mv/wp-content/uploads/2022/02/FAQ-Dashboard.pdf" target="_blank">
            <div class="card card-clickable" style="padding: 2em">
              <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_fi0ty9ak.json"  background="transparent"  speed="1"   loop center autoplay></lottie-player>
              <h5 class="faq-header">Frequently Asked Questions</h5>
            </div>
          </a>
          <ShippingAgents />
        </div>
        <div class="w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
          <div class="card">
            <div class="card-header">
              <div class="flex justify-between">
                <div>
                  <h2 class="card-heading">Important Contacts</h2>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="flex flex-wrap">
                <div class="w-full p-1">
                  <div class="bg-slate-100 rounded">
                    <div class="bg-red-500 contact-header">
                      Pilotage & Marine Service
                    </div>
                    <div class="px-3 py-3 text-xs text-gray-800">
                      <p class="mb-1">
                        <i class="fal fa-phone-office text-sm mr-2"></i>+960
                        3039402
                      </p>
                      <p class="mb-1">
                        <i class="fal fa-phone-square-alt text-sm mr-2"></i
                        >pmd@port.mv
                      </p>
                    </div>
                  </div>
                </div>

                <div class="w-full p-1">
                  <div class="bg-slate-100 rounded">
                    <div class="bg-purple-500 contact-header">
                      Cargo Clearance
                    </div>
                    <div class="px-3 py-3 text-xs text-gray-800">
                      <p class="mb-1">
                        <i class="fal fa-phone-office text-sm mr-2"></i>+960
                        3039303
                      </p>
                      <p class="mb-1">
                        <i class="fal fa-phone-square-alt text-sm mr-2"></i
                        >clearance@port.mv
                      </p>
                    </div>
                  </div>
                </div>

                <div class="w-full p-1">
                  <div class="bg-slate-100 rounded">
                    <div class="bg-green-500 contact-header">
                      Cargo Operations
                    </div>
                    <div class="px-3 py-3 text-xs text-gray-800">
                      <p class="mb-1">
                        <i class="fal fa-phone-office text-sm mr-2"></i>+960
                        3039340
                      </p>
                      <p class="mb-1">
                        <i class="fal fa-phone-square-alt text-sm mr-2"></i
                        >cargo@port.mv
                      </p>
                    </div>
                  </div>
                </div>

                <div class="w-full p-1">
                  <div class="bg-slate-100 rounded">
                    <div class="bg-blue-500 contact-header">
                      Data Processing Unit
                    </div>
                    <div class="px-3 py-3 text-xs text-gray-800">
                      <p class="mb-1">
                        <i class="fal fa-phone-office text-sm mr-2"></i>+960
                        3322355
                      </p>
                      <p class="mb-1">
                        <i class="fal fa-phone-square-alt text-sm mr-2"></i
                        >dpu@port.mv
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Tarrifs/>
        </div>
        <div class="w-full">
          <KnowledgeCenter />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import UserService from "@/services/user.service";
import ContainerSearch from "@/components/ContainerSearch.vue";
import ShipsAtPort from "@/components/ShipsAtPort.vue";
import EstimatedArrival from "@/components/EstimatedArrival.vue";
import KnowledgeCenter from "@/components/KnowledgeCenter.vue";
import ShippingAgents from "@/components/ShippingAgents.vue";
import OverallStatistics from "@/components/OverallStatistics.vue";
import Tarrifs from "@/components/Tarrifs.vue";
import WeatherForecast from "@/components/WeatherForecast.vue";
import ScreenAlert from "@/components/ScreenAlert.vue";

@Component({
  components: {
      ContainerSearch,
    ScreenAlert,
    ShipsAtPort,
    EstimatedArrival,
    KnowledgeCenter,
    ShippingAgents,
    OverallStatistics,
    Tarrifs,
    WeatherForecast,
  },
})
export default class MainPage extends Vue {
  
}
</script>
